'use strict';
const angular = require('angular');

/*@ngInject*/
export function StorageService($resource) {

  return $resource('/api/storage/:id/:controller', {
    id: '@_id'
  },{
    getMeta: {
      method: 'GET',
      params: {
        controller: 'meta'
      }
    },
    queryByOwner: {
      method: 'GET',
      url: "/api/storage/owner/:userid",
      isArray: true
    },
    getFileSize: {
      method: 'GET',
      url: '/api/storage/:id/file-size'
    }
  });

}

export default angular.module('conduu.StorageService', [])
  .factory('StorageService', StorageService)
  .name;



// WEBPACK FOOTER //
// ./client/components/storage/storage.service.js